module.exports = __webpack_public_path__ + "img/list_portrait_default@3x.a9045af6.png";